//---Centralize auth-related API calls → no axios logic in context.---//
import api from "./axios";

export async function login(username: string, password: string) {
  const res = await api.post("/auth/login/", { username, password });
  return res.data;
}

export async function logout() {
  return api.post("/auth/logout/");
}

export async function refreshToken() {
  const res = await api.post("/auth/refresh/");
  return res.data.access as string;
}

export async function getSession() {
  return api.post("/auth/session/");
}

export async function getMe() {
  return api.get("/auth/protected/");
}
